export const detail = {
    routeTitle: 'List of residents for currently loaded home',
    listOfUsers: 'List of residents',
    homeDetail: 'Detail',
    metersLabel: 'Meters',
    usersLabel: 'Users in home',
    siteConfig: 'Site Configuration',
    noUsersLabel: 'No residents in selected home',
    detailRouteTitle: 'Home detail',
    detailRoute: 'Detail',
    detailInformationTitle: 'Home information',
    deleteConfirmTitle: 'Are you sure you want to delete this home?',
    deleteConfirmDescription: ['Home with name', 'will be permanently deleted.'],
    // Meters
    addMeterButton: 'Add new meter',
    addMeterModalTitle: 'Add new meter device',
    addDeviceModalTitle: 'Add new device to current meter',
    addDeviceButton: 'Add device',
    editDeviceModalTitle: 'Edit device on current meter',
    canNotFetchDevicesForDeletedMeter: 'Not possible to fetch devices for deleted meter.',
    deleteDeviceModalTitle: 'Are you sure you want to delete this device on current meter?',
    deleteDeviceConfirmDescription: [
        'Device on current meter with name',
        'will be removed after this action.'
    ],
    undeleteDeviceOrMeter: 'will be renewed after this action.',
    deleteMeterModalTitle: 'Are you sure you want to delete this meter device?',
    deleteMeterConfirmDescription: ['Meter device with name', 'will be removed after this action.'],
    editMeterModalTitle: 'Edit meter details',
    editDeviceButton: 'Edit device',
    meterName: "Meter's name",
    capacity: "Capacity (kWp / kWh)",
    installationDate: "Installation Date",
    meterMacAddress: 'Mac Address',
    meterMacAddressFormatField:
        'Mac Address format is not valid. Allowed characters are a-f A-F and 0-9. Allowed length is 12 characters.',
    meterIpAddress: 'IP Address',
    meterUrl: 'URL',
    enphaseUser: 'Enphase User',
    enphaseSerial: 'Enphase Serial',
    meterReadingsPerMinute: 'Reading per 1 minute',
    meterType: 'Type of meter',
    noDevicesOnMonitor: 'No devices added on current meter device.',
    deviceName: 'Device name',
    deviceQuality: 'Device quality',
    deviceType: 'Device Type',
    deviceCountLabel: 'Number of identical instances',
    subscriptionType: 'Subscription type',
    subscriptionUntil: 'Subscription until',
    partner: 'Partner',
    purpose: 'Purpose',
    flavor: 'Modbus Flavor',
    modbusId: 'Modbus Id',
    hub: 'Controller',
    production: 'Production',
    grid: 'Grid',
    usage: 'Usage',
    storage: 'Storage',
    hubDetails: 'Controller Details',
    deleteMessages: 'Delete Messages',
    status: 'Status',
    age: 'Age',
    message: 'Message',
    switchStatus: 'Status',
    meterStatus: 'Status',
    noController: '-- none --',
    activateSupport: 'Activate online support',
    deactivateSupport: 'Deactivate online support',
    onlineSupportLabel: 'Online Support',
    onlineSupportUnknown: 'Unknown',
    onlineSupportActive: 'Active',
    onlineSupportNotActive: 'Inactive',
    errorAlertTitle: 'Caution',
    errorAlertMessage: 'This device is attached to a switch. Please delete the switch or detach the device before deleting it.',
    triggerUpdateWaPi: 'Update WA-PI',
    triggerUpdateWaSem: 'Update WA-SEM',
    triggerUpdateMeterSupport: 'Update Meter Support',
    triggerUpdateEvcc: 'Update Evcc',
    triggerReadCompleteConfig: 'Read complete config',
    triggerReboot: 'Reboot',
    triggerRestartWaPi: 'Restart Wa-Pi',
    triggerRestartWaSem: 'Restart Wa-Sem',
    triggerRestartWaMeterSupport: 'Restart Wa-Meter-Support',
    triggerInstallLogConfigs: 'Install log-configs',
    triggerInstallLog2Ram: 'Install log2ram',
    mergeModalTitle1: 'Merge "',
    mergeModalTitle2: '" into:',
    mergeModalOk: 'Merge',

    // Users
    invitedUsers: 'Invited residents',
    owner: 'Owner',
    userName: 'Name',
    userSurname: 'Surname',
    userEmail: 'Email address',
    addUser: 'Add new resident',
    sureToDeleteContent: 'Deleted invite email is: ',
    sureToDeleteHelp: 'For confirmation, please insert name of user',

    modbusStateFunctionCode: "Modbus function-code for state",
    modbusStateRegisterStartAddress: "Modbus register start-address for state",
    modbusStateRegisterQuantity: "Modbus register-quantity for state",
    modbusStateMinValue: "Modbus min-Value for state",
    modbusStateMaxValue: "Modbus max-Value for state",
    modbusStateDataType: "Modbus datatype for state",
    modbusStateFactor: "Modbus factor (min- and max-values will be multiplied) for state",

    modbusWattFunctionCode: "Modbus function-code for reading watt-values",
    modbusWattRegisterStartAddress: "Modbus register start-address for reading watt-values",
    modbusWattRegisterQuantity: "Modbus register-quantity for reading watt-values",
    modbusWattDataType: "Modbus datatype for reading watt-values",
    modbusWattFactor: "Modbus factor for read watt-values",

    modbusTempFunctionCode: "Modbus function-code for reading temperature-values",
    modbusTempRegisterStartAddress: "Modbus register start-address for reading temperature-values",
    modbusTempRegisterQuantity: "Modbus register-quantity for reading temperature-values",
    modbusTempDataType: "Modbus datatype for reading temperature-values",
    modbusTempFactor: "Modbus factor for reading temperature-values",
    meterA: "Meter A",
    meterB: "Meter B",
    meterSoc: "Meter for SoC",
    solaxRegistrationNr: "Registration number",
    neoomBeaamApiKey: 'Key for BEAAM API',
};